export const INTER = "Montserrat, sans-serif";
